




import { defineComponent, computed } from '@nuxtjs/composition-api'
import { useProductStore } from '~/store/product'
import { PDPTemplateComponent } from '~/modules/contentstack/pdpTemplateParser'
import ProductInformation from '@/components/feature/PDP/ProductInformation.vue'

export default defineComponent({
  components: { ProductInformation },
  props: {
    templateComponentData: {
      type: Object as () => PDPTemplateComponent,
      required: true,
    },
  },
  setup(props) {
    const productStore = useProductStore()

    const productInformationProp = computed(() => {
      return productStore.getProductInformationPropData(
        productStore.currentProduct.data.key,
        props.templateComponentData.components.map((a: any) => a.name)
      )
    })

    return { productInformationProp }
  },
})
